/**
 * Réserve un écran aux superadministrateurs, au sens de `requireSuperAdmin`.
 *
 * Distinct de `superadmin`, qui exige le rôle porté par l'annuaire : celui-ci
 * accepte aussi le rôle superadmin de cette seule application, et suit donc ce
 * que les routes appelées vérifient elles-mêmes.
 *
 * Ce n'est pas la protection — les routes tranchent côté serveur. Il évite
 * seulement d'ouvrir un écran dont chaque action échouerait en 403.
 */
export default defineNuxtRouteMiddleware(() => {
  const auth = useAuthStore()

  // La session peut n'être pas encore chargée au premier rendu : `auth.global`
  // l'a demandée, et laisser passer ici évite un renvoi injustifié.
  if (auth.loading) return

  if (!auth.isSuperAdmin) {
    throw createError({
      statusCode: 403,
      statusMessage: 'Accès réservé aux superadministrateurs',
      fatal: true,
    })
  }
})
